export default __webpack_public_path__ + "static/media/secret_3.e6465060.jpg";